import React from 'react';
import { connect } from 'react-redux';
import { compose, lifecycle, withStateHandlers, branch, renderComponent } from 'recompose';
import EditorStandartLayout from '../../editor/components/controls/EditorStandartLayout';
import { Divider } from 'material-ui';
import { setWidgets, loadWidgets } from '../actions';
import { List, ListItem } from 'material-ui/List';
import _ from 'lodash';
import { setTemplate } from '../actions';
// import WidgetList from '../components/WidgetList';

import WidgetPicker from '../components/WidgetPicker';

const WidgetPickerEnhanced = compose(
    connect(
        ({ widgetPicker }, props) => {
            return {
                template: widgetPicker.template || props.template,
                tab: 'all',
            };
        },
        (dispatch, { onWidgetSelected, onTemplateSelected }) => ({
            loadWidgets,
            setTemplate,
            onTemplateChanged: template => {
                dispatch(setTemplate(template));
                if (onTemplateSelected) onTemplateSelected(template);
            },
            onWidgetSelected:
                onWidgetSelected ||
                ((e, widget) => {
                    alert('widget selected' + widget.id);
                }),
        }),
    ),
    withStateHandlers(
        () => ({
            tab: 'all',
            params: {},
        }),
        {
            onTabOpen: (state, { onTabOpen }) =>
                onTabOpen ||
                ((tab, params) => {
                    return { tab, params };
                }),
        },
    ),
    lifecycle({
        componentWillReceiveProps(nextProps) {
            if (this.props.template !== nextProps.template) this.props.setTemplate(nextProps.template);
        },
        componentDidMount() {
            if (this.props.template) this.props.setTemplate(this.props.template);
        },
    }),
)(WidgetPicker);

export default WidgetPickerEnhanced;



/** WEBPACK FOOTER **
 ** ../src/dash/front/widget-picker/containers/WidgetPickerStandalone.js
 **/